import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { ConfigService } from 'esz-saas-lcp-ng-crud-ui';
import { NewsletterService } from './newsletter.service';

@Component({
    standalone: false,
    selector: 'app-ws-footer',
    templateUrl: './ws-footer.component.html'
})
export class WsFooterComponent {
    email = '';
    isSubmitting = false;
    /** Stays true after a success: one submission per page load keeps under the forms tier's 3/min IP limit. */
    subscribed = false;
    errorMessage = '';

    constructor(public configService: ConfigService, public newsletter: NewsletterService) { }

    subscribe(form: NgForm): void {
        if (form.invalid) { form.control.markAllAsTouched(); return; }
        this.isSubmitting = true; this.errorMessage = '';
        this.newsletter.subscribe(this.email.trim()).subscribe({
            next: () => { this.isSubmitting = false; this.subscribed = true; },
            error: (err: HttpErrorResponse) => {
                this.isSubmitting = false;
                this.errorMessage = err.status === 429
                    ? 'Too many attempts from this network. Please try again in a minute.'
                    : 'Sorry, that did not go through. Please try again later.';
            }
        });
    }
}
